module.exports = __webpack_public_path__ + "00f0575bd0c7409ededab0fceacc9a8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/17.jpg
// module id = 1343
// module chunks = 47